module.exports = __webpack_public_path__ + "static/media/onboarding-logo.01a872ad.png";